import { useLocation } from 'react-router-dom';
import React, { useState, useEffect, useContext } from 'react';
import './SidebarDepartment.scss';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { getLogoName, listenToEvent, removeListener } from '../../Helpers/utils';
import { getRole } from '../../Helpers/utils';
import { UserInfo } from "../../Context/userInfo";

const SidebarDepartment = ({ isOpen, toggleSidebar }) => {
  const { userData, updateUserData } = useContext(UserInfo);
  const [roles, setRoles] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    if (userData) {
      setRoles(getRole(userData.data?.userInfo?.roles));
    }
  }, [userData]);

  const [showClass, setShowClass] = useState('');
  const setToggle = (data) => {
    setShowClass((prev) => (prev === data ? '' : data));
  };

  const icons = {
    dashboard: 'bx bx-line-chart',
    tickets: 'bx bx-support',
    support: 'fa-solid fa-building',
    dataApis: 'fa-solid fa-calendar-days',
    customView: 'bx bx-line-chart',
  };

  return (
    <div className={`sidebar-department ${isOpen ? 'open' : 'close'}`}>

      <ul className="nav-links">

        <li onClick={() => setToggle('Departments-tickets')} style={{ marginTop: '15%' }}>
          <div className={`icon-link ${showClass == 'Departments-tickets' ? "icon-link1" : ''}`} onClick={() => {
            navigate("/Departments-tickets");
          }}>
            <Link className="loginhere-link">
              <i className={icons.tickets} style={{ color: '#000' }}></i>
              <span className="link_name" style={{ color: '#000' }}>Tickets</span>
            </Link>
          </div>
          <ul className="sub-menu" style={{ padding: '12px 12px ', backgroundColor: "#0e2b4e" }}>
            <li className={`li-setting icon-link ${showClass == 'Departments-tickets' ? "icon-link1" : ''}`} style={{ padding: '9px' }} onClick={(e) => {
              e.stopPropagation();
              setShowClass('Departments-tickets'); // Ensure the submodule stays open
              navigate("/Departments-tickets");
            }}>
              <Link className="loginhere-link" style={{ padding: "0px 20px" }}>
                <i className={icons.tickets} style={{ color: '#000' }}></i>
                <span className={`${showClass != 'Departments-tickets' ? "link_name1" : 'link_name2'}`} style={{ color: '#000' }}>Tickets</span>
              </Link>
            </li>
          </ul>
        </li>

        <li className="mt-3">
          <div className="icon-link">
            <Link className="loginhere-link" style={{ display: "flex", alignItems: "center" }}>
              <i className={icons.support} style={{ color: '#000', fontSize: '20px' }}></i>
              <span className="link_name" style={{ color: '#000', marginLeft: '10px' }}>Call Care Support</span>
            </Link>
          </div>
        </li>

        <li className="mt-3">
          <div className="icon-link">
            <Link className="loginhere-link" style={{ display: "flex", alignItems: "center" }}>
              <i className={icons.dataApis} style={{ color: '#000', fontSize: '20px' }}></i>
              <span className="link_name" style={{ color: '#000', marginLeft: '10px' }}>Data Services Apis</span>
            </Link>
          </div>
        </li>

        <li className="mt-3">
          <div className="icon-link">
            <Link className="loginhere-link" style={{ display: "flex", alignItems: "center" }}>
              <i className={icons.customView} style={{ color: '#000', fontSize: '20px' }}></i>
              <span className="link_name" style={{ color: '#000', marginLeft: '10px' }}>Custom View</span>
            </Link>
          </div>
        </li>

      </ul>
    </div>
  );
};

export default SidebarDepartment;
